import axios from 'axios'
import {
  getApiBaseUrl,
  getApiTimeoutMs,
  isApiUseRelative,
  isCredentialsRequired,
} from '@/config/api/env.js'

const explicitBase = getApiBaseUrl()
const baseURL = explicitBase.length > 0 ? explicitBase : isApiUseRelative() ? '' : ''

const axiosClient = axios.create({
  baseURL,
  timeout: getApiTimeoutMs(),
  withCredentials: isCredentialsRequired(),
})

export default axiosClient
